"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _LazyImg = _interopRequireDefault(require("./LazyImg"));
var _Title = _interopRequireDefault(require("../../Title"));
var _utils = require("../../utils");
function FlexInternationalLogo(props) {
  var _a = props || {},
    style = _a.style,
    flexTitle = _a.flexTitle,
    desc = _a.desc,
    _b = _a.configuration,
    configuration = _b === void 0 ? [] : _b;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex-international-home-brand-container'),
    style: (0, _typeof2["default"])(style) === 'object' ? style : {}
  }, flexTitle ? /*#__PURE__*/_react["default"].createElement(_Title["default"], {
    title: flexTitle,
    desc: desc
  }) : '', /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex-home-brand-inner')
  }, /*#__PURE__*/_react["default"].createElement("ul", {
    className: (0, _classnames["default"])('flex-home-brand-group')
  }, configuration.map(function (items, index) {
    var _a = items || {},
      imageSrc = _a.imageSrc,
      href = _a.href;
    var _b = (0, _utils.fomateFileData)(imageSrc),
      url = _b.url,
      _c = _b.alt,
      alt = _c === void 0 ? '' : _c;
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: index
    }, href ? ( /*#__PURE__*/_react["default"].createElement("a", {
      href: href,
      "report-event": "click_flexInternationalLogo_href",
      "report-ext1": index,
      "report-ext2": href,
      className: (0, _classnames["default"])('flex-home-brand-item', {
        'has-href': !!href
      }),
      target: "_blank",
      rel: "noreferrer"
    }, /*#__PURE__*/_react["default"].createElement(_LazyImg["default"], {
      className: (0, _classnames["default"])('brand-list-img'),
      src: url,
      alt: alt
    }))) : ( /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('flex-home-brand-item')
    }, /*#__PURE__*/_react["default"].createElement(_LazyImg["default"], {
      className: (0, _classnames["default"])('brand-list-img'),
      src: url,
      alt: alt
    }))));
  }))));
}
var _default = exports["default"] = FlexInternationalLogo;